var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.VALUE == '2')?_c('vs-chip',{attrs:{"color":"success"}},[_vm._v(" Aktif")]):(_vm.VALUE == null)?_c('div',{attrs:{"color":"danger"}}):_c('vs-chip',{attrs:{"color":"danger"}},[_vm._v("\n    Pasif\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }